<template>
    <div class="pagination" v-if="totalPages > 1">
        <button
            class="pagination-button"
            id="prevPage"
            @click="changePage(parseInt(page) - 1)"
            v-if="page > 1"
        >
            &lang;&nbsp;&nbsp;Prev
        </button>
        <PaginationButton
            class="pagination-button page-number"
            v-for="(number, index) in pageNumbers"
            :page="number"
            :iscurrent="page == number"
            :key="`pagination-button-${index}`"
            @changePage="$emit('changePage', $event)"
        />
        <button
            class="pagination-button"
            id="nextPage"
            @click="changePage(parseInt(page) + 1)"
            v-if="page < totalPages"
        >
            Next&nbsp;&nbsp;&rang;
        </button>
    </div>
</template>

<script>
import PaginationButton from '@/components/PaginationButton';

export default {
    components: {
        PaginationButton,
    },
    props: ['totalPages', 'page'],
    computed: {
        pageNumbers() {
            let buttons = [];
            if (!this.totalPages || parseInt(this.totalPages) < 1)
                return buttons;
            for (let i = 1; i < this.totalPages + 1; i++) {
                if (this.totalPages < 7) {
                    buttons.push(i);
                } else {
                    switch (i) {
                        case this.page - 1:
                        case this.page + 1:
                        case this.page:
                        case 1:
                        case this.totalPages: {
                            buttons.push(i);
                            break;
                        }

                        default: {
                            // buttons.push('hidden');
                        }
                    }
                }
            }

            if (this.totalPages > 6 && this.page > 3) {
                buttons.splice(1, 0, 'elipsis');
            }

            if (this.totalPages > 6 && this.page < this.totalPages - 3) {
                buttons.splice(-1, 0, 'elipsis');
            }

            return buttons;
        },
    },
    methods: {
        changePage(page) {
            new Promise((resolve) => {
                const appRect = document
                    .querySelector('#announcementsList')
                    .getBoundingClientRect();

                try {
                    const options = {
                        top: appRect.top,
                        behavior: 'smooth',
                    };

                    window.scrollTo(options);
                    resolve();
                } catch {
                    window.scroll(0, appRect.top);
                    resolve();
                }
            }).then(() => {
                this.$emit('changePage', page);
            });
        },
    },
};
</script>
